import { createSelector } from '@ngrx/store';
import * as fromFeature from '@app/shared/store/reducers';
import * as fromToast from '@app/shared/store/reducers/toast.reducers';

export const selectToastState = createSelector(
  fromFeature.selectSharedFeatureState,
  (state: fromFeature.State) => state.toastMessages
);

export const getToastMessages = createSelector(
  selectToastState,
  fromToast.getToastMessages
);
